import { takeLeading } from "redux-saga/effects";

import startup from "./startup";

export function* rootSaga() {
  yield takeLeading("APP_STARTUP", startup);
}
